import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ProfileContext } from '../context/ProfileContext';
import { IonPage, IonContent, IonSpinner, IonButton, IonIcon } from '@ionic/react';
import { lockClosedOutline } from 'ionicons/icons';

const PortalEntry: React.FC = () => {
  const history = useHistory();
  const { usersID, profile } = useContext(ProfileContext);
  const [accessDeniedReason, setAccessDeniedReason] = useState<string | null>(null);

  useEffect(() => {
    // Check authentication and subscription status
    if (!usersID) {
      // Not authenticated - redirect to login with return URL
      history.push('/login?returnUrl=/portal');
      return;
    }

    // Check if user has scheduler role
    const isScheduler = profile?.UserLastRoleScheduler === true || profile?.UserLastRoleScheduler === 'true';
    
    if (!isScheduler) {
      // Not a scheduler - show message
      setAccessDeniedReason('scheduler');
      return;
    }

    // All checks passed - redirect to Home (scheduler portal)
    history.push('/Home');
  }, [usersID, profile, history]);

  // Show access denied message if user doesn't have scheduler role
  if (accessDeniedReason === 'scheduler') {
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            flexDirection: 'column',
            textAlign: 'center',
            maxWidth: '500px',
            margin: '0 auto'
          }}>
            <IonIcon 
              icon={lockClosedOutline} 
              style={{ fontSize: '5rem', color: '#f4b41a', marginBottom: '1.5rem' }}
            />
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: '#1a1a1a' }}>
              Scheduler Account Required
            </h1>
            <p style={{ fontSize: '1.1rem', color: '#666', lineHeight: '1.7', marginBottom: '2rem' }}>
              The web portal is available to detail coordinators and schedulers with an active subscription. 
              Officers can access their details through the mobile app.
            </p>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
              <IonButton
                onClick={() => history.push('/')}
                fill="solid"
                color="warning"
              >
                Back to Home
              </IonButton>
              <IonButton
                onClick={() => history.push('/Home')}
                fill="outline"
                color="medium"
              >
                Go to App
              </IonButton>
            </div>
            <div style={{ marginTop: '2rem', padding: '1.5rem', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <p style={{ fontSize: '0.95rem', color: '#666', margin: 0 }}>
                <strong>Need scheduler access?</strong><br />
                Contact your department coordinator or email support@werkapp.com
              </p>
            </div>
          </div>
        </IonContent>
      </IonPage>
    );
  }

  // Show loading spinner while checking credentials
  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column'
        }}>
          <IonSpinner name="crescent" style={{ fontSize: '3rem' }} />
          <p style={{ marginTop: '1.5rem', color: '#666', fontSize: '1.1rem' }}>Verifying access...</p>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default PortalEntry;
